import React, {Component} from 'react';
import { Badge, Row, Col, CardHeader, InputGroup, InputGroupAddon, InputGroupButton,  Fade, Input, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter, Container, 
  Card, CardBody, Form, FormGroup,  FormFeedback } from 'reactstrap';


import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Icon from '@material-ui/core/Icon';
import GroupIcon from '@material-ui/icons/ShortText';
import NavigationIcon from '@material-ui/icons/Navigation';
import Sternenbewertung from './Sternenbewertung';
import OffeneFragen from './OffeneFragen';
import TextField from '@material-ui/core/TextField';
//import { Badge } from 'material-ui';
//import StarRatings from './react-star-ratings';
import Rating from 'react-rating';
import VisualClipComponent from './VisualClipComponent';
import CheckBoxTrueFalse from './CheckBoxTrueFalse';
import MultiSelectView from './MultiSelectView';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';


const styles = theme => ({
  fab: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
});

class CorrectView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false, 

    };

  this.toggle = this.toggle.bind(this);
  this.closeModal = this.closeModal.bind(this);

  }

  async toggle(e) {
          
    this.setState({
      modal: !this.state.modal
    });
  }




  closeModal(e){

    this.toggle();

   }


   checkSSForTrue(question){
     var localanswers = question.answers[0] == [] ? false : question.answers[0]
     var localanswer = question.answer == [] ? false : question.answer
     return localanswers == localanswer
   }

   checkMSForTrue(question){
  //  var localanswers = question.answers[0] == [] ? false : question.answers[0]
  //  var localanswer = question.answer == [] ? false : question.answer

    var retvalue = true; 

    question.answers && question.answers.length > 0 && question.answers.map( answer => {

      if (answer.answer != answer.answers[0]) {retvalue = false;  return;}

    })
    

    return retvalue
  }

  
  render() {
	  	  	  	  
    const { classes } = this.props;
    var localthis = this;
    var ReactFitText = require('react-fittext');

    return (
      <div>
        { /*
        <ReactFitText>
          <h2>
            <Fab variant="extended" color={this.props.color} aria-label="Toggle" disabled={this.props.disable} onClick={this.toggle} className={classes.fab} size="small">
              <GroupIcon className={classes.extendedIcon} />
              {this.props.buttonLabel}
            </Fab>
          </h2>
        </ReactFitText>
        */}

        <Button color="primary" disabled={this.props.disable} onClick={this.toggle}> {this.props.buttonLabel} </Button>

        <Modal isOpen={this.state.modal} toggle={this.toggle} size="lg" className={this.props.className}>
    
          <ModalHeader toggle={this.toggle}>Gegenüberstellung Fragen/Antworten</ModalHeader>
          <ModalBody>
 
          <Card>
      <CardHeader>Erklärung </CardHeader>
      <CardBody>
          <Container>
          <Card>
            <CardBody>
            <Grid container spacing={2}>           
              <Grid  item xs>Angekreuzt</Grid>
              <Grid  item xs><Checkbox checked={true} /></Grid>
           </Grid>
           <Grid container spacing={2}>           
              <Grid  item xs>Nicht angekreuzt</Grid>
              <Grid  item xs><Checkbox checked={false} /></Grid>
           </Grid> 


           <Card body outline color={ "success"}>
             <CardBody>
               <CardHeader style={{backgroundColor: '#28a745', color: 'white'} }>
           <Grid container spacing={2}>           
              <Grid  item xs>Richtig beantwortet</Grid>
           </Grid> 
           </CardHeader>
           </CardBody>
           </Card>
           <br/>
           <Card body outline color={ "danger"}>
             <CardBody>
             <CardHeader style={{backgroundColor: '#dc3545', color: 'white'} }>

           <Grid container spacing={2}>           
              <Grid  item xs>Falsch beantwortet</Grid>
           </Grid> 
           </CardHeader>
           </CardBody>
           </Card>


            </CardBody>
          </Card>
        </Container>
        </CardBody>
        </Card>


          {
  this.props.ssmsquestions && this.props.ssmsquestions.length > 0 ? (
    <Card>
      <CardHeader> SingleSelect / Multiselect Abschnitt </CardHeader>
      <CardBody>

       { <Container> {
         this.props.ssmsquestions.map( (question, i, arr) =>

         <div>

          {
            question.qtype == "ss" ?  <div>
             <Card body outline color={ this.checkSSForTrue(question) ? "success" : "danger"}>
               
               { 
                  this.checkSSForTrue(question) ? <CardHeader style={{backgroundColor: '#28a745', color: 'white'} } > SingleSelect Frage - Richtig/Falsch</CardHeader> : 
                  <CardHeader style={{backgroundColor: '#dc3545', color: 'white'} } > SingleSelect Frage - Richtig/Falsch</CardHeader>                  
               }
                       
            <CardBody>
           
            <Grid container spacing={3}>           
              <Grid  item xs>Frage</Grid>
              <Grid  item xs>Ihre Antwort</Grid>
              <Grid  item xs>Korrekte Antwort</Grid>
           </Grid>
                <Grid container spacing={3}>
                    <Grid  item xs>
                        <p>{question.value}</p>
                    </Grid>
                    <Grid  item xs>
                        <Checkbox checked={question.answers[0] == [] ? false : question.answers[0]}  value="checked" />
                    </Grid>
                    <Grid  item xs>
                        <Checkbox checked={question.answer == [] ? false : question.answer}  value="checked" />
                    </Grid>                    
                </Grid>
                     
 
                   </CardBody> </Card> </div> :
                 <div> <Card body outline color={this.checkMSForTrue(question) ? "success" : "danger"}>

                   {

                     this.checkMSForTrue(question) ? <CardHeader style={{ backgroundColor: '#28a745', color: 'white' }} >  {question.value}</CardHeader> :
                       <CardHeader style={{ backgroundColor: '#dc3545', color: 'white' }} >  {question.value} </CardHeader>
                   }


                   <CardBody>
            <Grid container spacing={3}>
              <Grid  item xs>Frage</Grid>
              <Grid  item xs>Ihre Antwort</Grid>
              <Grid  item xs>Korrekte Antwort</Grid>
           </Grid>              
              {
                question.answers && question.answers.length > 0 && question.answers.map( subitem => <div>
                <Grid container spacing={3}>
                    <Grid  item xs>
                        <p>{subitem.value}</p>
                    </Grid>
                    <Grid  item xs>
                        <Checkbox checked={subitem.answers[0] == [] ? false : subitem.answers[0]}  value="checked" />
                    </Grid>
                    <Grid  item xs>
                        <Checkbox checked={subitem.answer == [] ? false : subitem.answer}  value="checked" />
                    </Grid>                     
                </Grid>                  
                  </div>

                )
              }
             </CardBody> </Card></div>
            
          }
          { arr.length -1 === i ? null : <hr/>}
         </div>

        )
         }
        </Container>
       }
      </CardBody>
    </Card>
  ) : null
}


          </ModalBody>

          <ModalFooter>		              
			        <Button  color="primary" onClick={this.closeModal}>Schliessen</Button>		       
          </ModalFooter>



        </Modal>
      </div>
    );
  }
}

export default withStyles(styles)(CorrectView);




// WEBPACK FOOTER //
// ./src/modules/movie-browser/CorrectView.js